import React from "react";
import ForRentSetsDetails from "./for-rent-sets-details/for-rent-sets-details";

const ForRentSetsDetailsContainer = () => {
    return (
        <>
            <div style={{ padding: 20 }}>
                <ForRentSetsDetails/>
            </div>
        </>
    )
};

export default ForRentSetsDetailsContainer;